import type { IStep } from '../context/StepsContext'

export const stepsVehicle: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    path: '/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    path: '/steps/4',
  },
]


export const stepsLeasing: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/leasing/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/leasing/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    path: '/leasing/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    path: '/leasing/steps/4',
  },
]

export const stepsFleet: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/fleet/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/fleet/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    path: '/fleet/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    path: '/fleet/steps/4',
  },
]

export const stepsVehicleExtra: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/extra/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/extra/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    path: '/extra/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání smlouvy',
    path: '/extra/steps/4',
  },
]

export const stepsTravel: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/travel/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/travel/steps/2',
  },
  {
    id: 3,
    title: 'Osoby a doplnění údajů',
    path: '/travel/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    path: '/travel/steps/4',
  },
]


export const stepsProperty: IStep[] = [
  {
    id: 1,
    title: 'Základní údaje',
    path: '/property/steps/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/property/steps/2',
  },
  {
    id: 3,
    title: 'Doplnění údajů',
    path: '/property/steps/3',
  },
  {
    id: 4,
    title: 'Rekapitulace a sjednání',
    path: '/property/steps/4',
  },
]

export const stepsPoleas: IStep[] = [
  {
    id: 1,
    title: 'Kontrola údajů',
    path: '/poleas/wizard/1',
  },
  {
    id: 2,
    title: 'Kalkulace nabídek',
    path: '/poleas/wizard/2',
  },
  {
    id: 3,
    title: 'Doplnění údajů',
    path: '/poleas/wizard/3',
  },
  {
    id: 4,
    title: 'Sjednání',
    path: '/poleas/wizard/4',
  },
]
